module.exports = __webpack_public_path__ + "static/swag-63df031f0b8355561c63e5cf4ec09ba5.jpg";